import {
	type CommandConstructor,
	type CommandProperties,
} from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

export type ReadSpaceCommandResult = {
	space: Space;
};

type Space = {
	title: string;
	root: SpaceContentItem[];
};

export type SpaceContentItem = {
	title: string;
	contentType: string;
	children: SpaceContentItem[];
};

export interface ReadSpaceCommandProperties extends CommandProperties {
	/**
	 * The unique identifier for the space to read.
	 */
	id: string;
}

/**
 * A command sent by a bridge API client to return the current space data shown in the staging area during the smart create space flow.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to return the current space data.
 */
export const ReadSpaceCommand: CommandConstructor<
	ReadSpaceCommandProperties,
	ReadSpaceCommandResult
> = createCommand<ReadSpaceCommandProperties, ReadSpaceCommandResult>('read-space-command');
